// opervex-frontend/src/Opervex/ServiceManagement/ServiceOrder.js

class ServiceOrder {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async findId(id) {
    return this.#_api.get("/ServiceManagement/ServiceOrder/" + id);
  }

  async update(id, data) {
    return this.#_api.put("/ServiceManagement/ServiceOrder/" + id, data);
  }

  async create(data) {
    return this.#_api.post("/ServiceManagement/ServiceOrder/", data);
  }

  async findAll() {
    return this.#_api.get("/ServiceManagement/ServiceOrder");
  }

  async reversal(id, data) {
    return this.#_api.post(`/ServiceManagement/ServiceOrder/${id}/Reversal`, data);
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "protocol",
        label: "Protocolo",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "idTask",
        label: "Id Tarefa",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "reversal",
        label: "Estorno",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "documentDate",
        label: "Data do Documento",
        type: "dateOnly",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default ServiceOrder;
